import React, { useEffect, useState } from 'react'
import { CategoryService, DigitalVaultService, LocalStorageService } from '../../../services';
import { withRouter, useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";
import DigitalVaultSearchView from '../../views/digital-vault-search/digital-vault-search.view';
import { NIL } from 'uuid';

const DigitalVaultSearchAction = (props) => {
    const {
        toggleCompletedRequesting,
        toggleLoadingRequesting,
        toggleErrorRequesting
    } = props;

    const url = process.env.REACT_APP_MIFIRMA_API;
    const localStorageService = new LocalStorageService();
    const categoryService = new CategoryService(url)
    const digitalVaultService = new DigitalVaultService(url);
    const token = localStorageService.getLocalStorageItem("token").idToken;
    const { state } = useLocation();

    const [isLoading, setIsLoading] = useState(true);

    const [companies, setCompanies] = useState([]);
    const [documents, setDocuments] = useState([]);

    const [selectedCompanyId, setSelectedCompanyId] = useState(0);
    const [selectedCategoryId, setSelectedCategoryId] = useState(0);
    const [selectedDocument, setSelectedDocument] = useState(null);

    const loadFilters = async (comId, catId) => {
        setIsLoading(true);

        try {
            const response = await categoryService.getCategoriesCompanies(token)
            if (response.statusCode == 200 && response.data) {
                setCompanies(response.data);
                if (response.data[0].id === NIL) {
                    setSelectedCompanyId(response.data[0].id);
                    setSelectedCategoryId(response.data[0].categories[0].id);
                    setIsLoading(false);
                    return
                }

                let companies = response.data.sort((a, b) => a.companyName.toLowerCase().localeCompare(b.companyName.toLowerCase()))
                await loadDocuments(comId || response.data[0].id, catId || 0, companies);
            } else {
                throw new Error(response.message || "Ocurrió un error obteniendo las categorías.")
            }
            setIsLoading(false);
        } catch (e) {
            toggleErrorRequesting(true, e.message, 4000, true)
        }
    }

    const loadDocuments = async (comId, catId, companiesAvailable = companies, globalSearch) => {
        setIsLoading(true);

        try {
            const selectedCompany = companiesAvailable.find(c => c.id == comId)
            const companyHasPermission = selectedCompany.hasSpecialPermission
            const categoryHasPermission = selectedCompany.categories.find(cat => cat.id == catId)?.hasSpecialPermission ?? false

            const response = await digitalVaultService.searchDocuments(token, comId, catId == 0 ? null : catId, companyHasPermission, categoryHasPermission, globalSearch)
            if (response.statusCode == 200 && response.data) {
                response.data.forEach(doc => {
                    doc.documentStartDate = new Date(`${doc.documentStartDate}${response.isCached ? '' : ' 00:00:00'}`)
                    if (doc.documentValidation) {
                        doc.documentValidation = new Date(`${doc.documentValidation}${response.isCached ? '' : ' 00:00:00'}`)
                    }
                });
                setDocuments(response.data)
            } else {
                throw new Error(response.message || "Ocurrió un error obteniendo las empresas.")
            }
            setIsLoading(false);
        } catch (e) {
            toggleErrorRequesting(true, e.message, 4000, true)
        }

        setSelectedCompanyId(comId);
        setSelectedCategoryId(catId);
    }

    useEffect(() => {
        if (state) {
            loadFilters(state.selectedCompanyId, state.selectedCategoryId);
            setSelectedDocument(state.selectedDocument);
        } else {
            loadFilters();
        }
    }, []);

    return (
        <DigitalVaultSearchView
            isLoading={isLoading}
            companies={companies}
            selectedCompanyId={selectedCompanyId}
            selectedCategoryId={selectedCategoryId}
            documents={documents}
            loadDocuments={loadDocuments}
            selectedDocument={selectedDocument}
            setSelectedDocument={setSelectedDocument}
        />
    )
}

export default withRouter(withTranslation()(DigitalVaultSearchAction));